export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 19 15" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100众筹" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="WEB-/--Bundles-tab" transform="translate(-1365.000000, -725.000000)" stroke={props?.stroke || "#165DFF"} strokeWidth="1.8">
                    <g id="-mockplus-" transform="translate(0.000000, 60.000000)">
                        <g id="编组-10" transform="translate(1366.000000, 666.714351)">
                            <line x1="4.26325641e-13" y1="5.70643453" x2="15" y2="5.70643453" id="路径-10"></line>
                            <polyline
                                id="路径"
                                transform="translate(10.080023, 5.706435) rotate(-135.000000) translate(-10.080023, -5.706435) "
                                points="14.1150817 9.74149309 6.12321036 9.66324735 6.04496462 1.67137598"
                            ></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
